export default class Advertisement {
    public title = "";
    public eyeCatch?: File;
    public image1?: File;
    public body1 = "";
    public image2?: File;
    public body2 = "";
    public image3?: File;
    public body3 = "";
    public image4?: File;
    public body4 = "";
    public image5?: File;
    public body5 = "";
};